module.exports = __webpack_public_path__ + "img/others.6b54422e.svg";